export { default as CoreBadge } from './badge';
export type {
  CoreBadgeProps,
  CoreBadgeVariant,
} from '../shared/types/badge.types';
